import React from 'react';
import { BarChart2, DollarSign, TrendingUp } from 'lucide-react';

export function ContractAnalytics() {
  const metrics = [
    {
      name: 'Total Contract Value',
      value: '$12.4M',
      change: '+15.3%',
      description: 'Year-over-year growth',
    },
    {
      name: 'Average Win Rate',
      value: '68%',
      change: '+4.2%',
      description: 'Last 30 days',
    },
    {
      name: 'Active Proposals',
      value: '24',
      change: '+2',
      description: 'From last month',
    },
  ];

  return (
    <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-gray-900/5">
      <h2 className="text-lg font-medium text-gray-900">Contract Analytics</h2>
      <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {metrics.map((metric) => (
          <div
            key={metric.name}
            className="relative overflow-hidden rounded-lg border border-gray-200 bg-white p-6"
          >
            <dt>
              <div className="absolute rounded-md bg-indigo-500 p-3">
                <BarChart2 className="h-6 w-6 text-white" />
              </div>
              <p className="ml-16 truncate text-sm font-medium text-gray-500">{metric.name}</p>
            </dt>
            <dd className="ml-16 flex items-baseline">
              <p className="text-2xl font-semibold text-gray-900">{metric.value}</p>
              <p className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                {metric.change}
              </p>
            </dd>
            <p className="ml-16 text-sm text-gray-500">{metric.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}